import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import { Anvil, Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: "", name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-navy">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-2xl p-8 shadow-xl" data-testid="register-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-sky-400 flex items-center justify-center">
            <Anvil className="w-5 h-5 text-navy" />
          </div>
          <span className="text-xl font-display font-bold text-navy">Fabriko</span>
        </div>
        <h2 className="text-2xl font-display font-bold text-navy">Créer votre atelier</h2>
        <p className="text-slate-500 mt-1 text-sm">Démarrez gratuitement en 30 secondes</p>

        {error && (
          <div className="mt-5 p-3 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm" data-testid="register-error">
            {error}
          </div>
        )}

        {[
          ["company_name", "Nom de l'atelier", "text"],
          ["name", "Votre nom", "text"],
          ["email", "Email", "email"],
          ["password", "Mot de passe", "password"],
        ].map(([k, label, type]) => (
          <div key={k}>
            <label className="block mt-4 text-sm font-medium text-slate-700">{label}</label>
            <input
              type={type}
              value={form[k]}
              onChange={set(k)}
              data-testid={`register-${k}-input`}
              className="mt-1.5 w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-400"
              required
            />
          </div>
        ))}

        <button
          type="submit"
          disabled={loading}
          data-testid="register-submit-button"
          className="mt-6 w-full py-3 rounded-xl bg-sky-400 text-navy font-semibold hover:bg-sky-500 transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          Créer mon atelier
        </button>

        <p className="mt-5 text-center text-sm text-slate-500">
          Déjà inscrit ?{" "}
          <Link to="/login" className="text-sky-600 font-semibold hover:underline" data-testid="go-login-link">
            Se connecter
          </Link>
        </p>
      </form>
    </div>
  );
}
